import SocketGuruService from 'ember-socket-guru/services/socket-guru';
import ENV from 'bullitttime-event/config/environment';

export default class SocketGuru extends SocketGuruService {
	constructor(properties) {
		// Set properties before calling super so parent constructor can use them
		const config = {
			host: ENV.eventBackendProtocol+"://"+ENV.eventBackendHost+":"+ENV.eventBackendPort,
			namespace: ENV.eventBackendNamespace ? "/"+ENV.eventBackendNamespace : ""
		};
		const observedChannels = ['heartbeat','startAssociationRecord','finishAssociationRecord','intermediateTimingRecord','massStartClassGroupAssociation','autoAssociationStateChanged','entryStatusChange'];

		// Call parent constructor with merged properties
		super({
			...properties,
			config,
			observedChannels
		});
	}
}